// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__279gR","balanceDisclaimer":"posDashboard_balanceDisclaimer__1IRbQ"};